<template>
  <f7-popup id="popup-balance" class="balance">
    <f7-view>
      <f7-page>
        <f7-navbar>
          <f7-nav-title>
            {{ $t(`page_balance.title`) }}
          </f7-nav-title>

          <f7-nav-right>
            <f7-link
              icon-f7="xmark"
              icon-color="gray"
              @click="$f7.popup.close()"
            ></f7-link>
          </f7-nav-right>
        </f7-navbar>

        <div class="page-content-inner">
          <f7-block-title>
            {{ $t(`page_balance.subtitle`) }}
          </f7-block-title>
          <!-- <f7-block class="margin-top margin-bottom">
            <p>{{ $t(`page_balance.subtitle`) }}</p>
          </f7-block> -->
          <f7-swiper
            class="select-slider select-slider--rate"
            :params="sliderOption"
          >
            <f7-swiper-slide v-for="(amount, index) in amounts" :key="index">
              <f7-button
                fill
                large
                :color="amount === selectAmount ? 'pink' : 'white'"
                :class="[
                  'select-slider-button',
                  'custome-large',
                  {
                    'select-slider-button--active gradient':
                      amount === selectAmount
                  }
                ]"
                @click="selectAmount = amount"
              >
                <div class="display-flex align-items-center">
                  {{ amount.text }}
                </div>
              </f7-button>
            </f7-swiper-slide>
          </f7-swiper>

          <f7-block-title class="margin-top no-margin-bottom">
            <p class="no-margin-vertical">
              {{ $t(`page_balance.promo_code`) }}
            </p>
          </f7-block-title>
          <f7-list
            class="popup-auth-list margin-bottom no-margin-top"
            no-hairlines
          >
            <f7-list-input
              ref="promoCode"
              type="text"
              floating-label
              :label="$t(`form_fields.promo_code.placeholder`)"
              :class="promoCode.valid ? 'valid-promo' : ''"
              :error-message-force="!!promoCode.error"
              :error-message="promoCode.error"
              :value="promoCode.value"
              @input="checkPromoCode"
            >
              <f7-preloader
                v-if="promoCode.isValidate"
                slot="content-end"
                class="align-self-flex-end"
                style="margin-bottom: 5px"
              ></f7-preloader>

              <f7-icon
                v-if="promoCode.valid"
                slot="content-end"
                class="align-self-flex-end"
                f7="check"
                color="green"
              ></f7-icon>
            </f7-list-input>
          </f7-list>

          <f7-block class="stellar-ratio-calculation">
            <p>
              {{
                `${$t(
                  `page_balance.stellar_calculation_message`
                )} ${starNumber} ⭐️`
              }}
            </p>
            <p
              v-if="selectAmount.totalValue"
              class="total-value-with-promocode"
            >
              {{
                `${$t(`page_balance.total_value_message`)} ${
                  selectAmount.totalValue
                } $`
              }}
            </p>
          </f7-block>

          <f7-block>
            <f7-button fill large class="custome-large gradient" @click="pay">
              {{ `${$t(`pay`)} ${selectAmount.value}$` }}
              <f7-preloader v-if="loadingPayment" color="white"></f7-preloader>
              <f7-icon
                v-else
                f7="arrow_right"
                color="white"
                size="24"
              ></f7-icon>
            </f7-button>
          </f7-block>

          <f7-block class="margin-bottom no-margin-top ref-code">
            <p>{{ $t(`page_balance.your_referral_code`) }}</p>
            <span>
              <div class="ref-code-text">
                {{ user.refCode }}
              </div>
              <f7-link
                class="ripple"
                icon-f7="document_text"
                icon-size="20"
                @click="
                  setClipboard(user.refCode, $t(`notify.referral_code_copied`))
                "
              ></f7-link>
            </span>
          </f7-block>

          <f7-block-title class="margin-top">
            {{ $t(`page_balance.promo_code`) }}
          </f7-block-title>
          <f7-list class="popup-auth-list margin-bottom" no-hairlines>
            <f7-list-input
              ref="cardReplenishment"
              type="text"
              floating-label
              :label="$t(`form_fields.card_replenishment_account.placeholder`)"
              :class="cardReplenishment.valid ? 'valid-promo' : ''"
              :error-message-force="!!cardReplenishment.error"
              :error-message="cardReplenishment.error"
              :value="cardReplenishment.value"
              @input="checkcardReplenishment"
            >
              <f7-preloader
                v-if="cardReplenishment.isValidate"
                slot="content-end"
                class="align-self-flex-end"
                style="margin-bottom: 5px"
              ></f7-preloader>

              <f7-icon
                v-if="cardReplenishment.valid"
                slot="content-end"
                class="align-self-flex-end"
                f7="check"
                color="green"
              ></f7-icon>
            </f7-list-input>
          </f7-list>

          <f7-block class="margin-top">
            <f7-button
              fill
              large
              class="custome-large gradient"
              @click="usecardReplenishment"
            >
              {{
                `${$t(`apply`)} ${
                  cardReplenishment.amount
                    ? `💎 (${cardReplenishment.amount})`
                    : ''
                }`
              }}
              <f7-preloader v-if="loadingPromo" color="white"></f7-preloader>
              <f7-icon
                v-else
                f7="arrow_right"
                color="white"
                size="24"
              ></f7-icon>
            </f7-button>
          </f7-block>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { mapState } from 'vuex';
import { debounce } from 'lodash';

import { setClipboard } from '@/js/helpers/utils.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  name: 'Balance',

  data() {
    return {
      sliderOption: {
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true
      },
      loadingPayment: false,
      loadingPromo: false,
      promoCode: {
        value: '',
        error: '',
        valid: false,
        isValidate: false
      },
      cardReplenishment: {
        value: '',
        id: null,
        amount: '',
        error: '',
        valid: false,
        isValidate: false
      },
      selectAmount: { value: '', totalValue: '', text: '' }
    };
  },

  computed: {
    setClipboard: () => setClipboard,

    starNumber() {
      return (
        (this.amounts.find((amount) => amount.value === this.selectAmount.value)
          .bonus +
          this.selectAmount.value) *
        this.user.starCoef
      );
    },

    ...mapState({
      user: (state) => state.user.info,
      amounts: (state) => state.amounts
    })
  },

  watch: {
    async 'selectAmount.value'(newValue, oldValue) {
      if (oldValue) {
        if (!this.promoCode.value) {
          this.promoCode.isValidate = false;
          this.promoCode.valid = false;
          this.promoCode.error = '';
          this.selectAmount.totalValue = '';
          return;
        }

        try {
          this.promoCode.isValidate = true;
          this.selectAmount.totalValue = '';

          const body = new FormData();
          body.append('amount', this.selectAmount.value);
          body.append('code', this.promoCode.value);

          const res = await apiRequest(`payment/code`, 'POST', body, true);

          this.promoCode.isValidate = false;

          if (res.error) {
            this.promoCode.error = res.error;
            this.promoCode.valid = false;
            return;
          }

          this.promoCode.valid = true;
          this.promoCode.error = '';
          this.selectAmount.totalValue = res.success;
        } catch (error) {
          this.promoCode.isValidate = false;
        }
      }
    }
  },

  created() {
    this.selectAmount = this.amounts[this.amounts.length - 2];
  },

  methods: {
    async pay() {
      const {
        selectAmount: { value: amount, totalValue }
      } = this;

      this.loadingPayment = true;

      const body = new FormData();
      body.append('amount', amount);
      totalValue ? body.append('code', this.promoCode.value) : null;
      // body.append('platform', this.$f7.device.os);

      await apiRequest('pay/create', 'POST', body, true).then((res) => {
        this.loadingPayment = false;

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        // this.$f7.device.android
        //   ? openBrowser(res.success)
        //   : console.log('Not implemented');
        this.promoCode.value = '';
        this.promoCode.isValidate = false;
        this.promoCode.valid = false;
        this.promoCode.error = '';
        this.selectAmount.totalValue = '';
        window.location.href = res.success;
        // const windowReference = window.open();
        // windowReference.location.href = res.success;
      });
    },

    checkPromoCode: debounce(async function(e) {
      this.promoCode.value = e.target.value;

      if (!this.promoCode.value) {
        this.promoCode.isValidate = false;
        this.promoCode.valid = false;
        this.promoCode.error = '';
        this.selectAmount.totalValue = '';
        return;
      }

      try {
        this.promoCode.isValidate = true;
        this.selectAmount.totalValue = '';

        const body = new FormData();
        body.append('amount', this.selectAmount.value);
        body.append('code', this.promoCode.value);

        const res = await apiRequest(`payment/code`, 'POST', body, true);

        this.promoCode.isValidate = false;

        if (res.error) {
          this.promoCode.error = res.error;
          this.promoCode.valid = false;
          return;
        }

        this.promoCode.valid = true;
        this.promoCode.error = '';
        this.selectAmount.totalValue = res.success;
      } catch (error) {
        this.promoCode.isValidate = false;
      }
    }, 300),

    checkcardReplenishment: debounce(async function(e) {
      this.cardReplenishment.value = e.target.value;

      if (!this.cardReplenishment.value) {
        this.cardReplenishment.isValidate = false;
        this.cardReplenishment.valid = false;
        this.cardReplenishment.error = '';
        return;
      }

      try {
        this.cardReplenishment.isValidate = true;
        this.cardReplenishment.id = null;
        this.cardReplenishment.amount = '';

        const res = await apiRequest(
          `promocode/get?code=${this.cardReplenishment.value}`,
          'GET',
          null,
          true
        );

        this.cardReplenishment.isValidate = false;

        if (res.error) {
          this.cardReplenishment.error = res.error;
          return;
        }

        this.cardReplenishment.valid = true;
        this.cardReplenishment.error = '';
        this.cardReplenishment.id = res.success.id;
        this.cardReplenishment.amount = res.success.amount;
      } catch (error) {
        this.cardReplenishment.isValidate = false;
      }
    }, 300),

    async usecardReplenishment() {
      const { id, valid, value: code } = this.cardReplenishment;

      if (!id && !valid) {
        notify({ text: this.$t(`notify.enter_promotional_code`) });
        return;
      }

      try {
        this.loadingPromo = true;

        const body = new FormData();
        body.append('id', id);
        body.append('code', code);

        const res = await apiRequest('promocode/use', 'POST', body, true);

        this.loadingPromo = false;

        if (res.error) {
          notify({ text: res.error });
          return;
        }
      } catch (error) {
        this.loadingPromo = false;
        notify({ text: this.$t(`notify.something_went_wrong`) });
      }
    }
  }
};
</script>

<style lang="less">
.balance {
  .popup-auth-list {
    padding: 0 15px;

    ul {
      &::after {
        display: block !important;
      }
    }
  }

  li.valid-promo {
    .item-inner {
      border-bottom-color: #4cd964;
    }
  }

  .ref-code {
    display: flex;
    flex-direction: column;

    p {
      margin-bottom: 5px;
    }

    span {
      display: flex;
      align-items: center;
      font-weight: 600;
      color: #000000;
      font-size: 18px;

      a.link {
        margin-left: 15px;
      }
    }
  }
}

.stellar-ratio-calculation {
  margin-top: 15px;
  margin-bottom: -15px;
}

.total-value-with-promocode {
  color: var(--f7-color-green);
}
</style>
